import { EditOutlined, EyeOutlined, FieldTimeOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Table, Space, Drawer, List, Avatar, Row, Col, Switch, Card, Descriptions, Tag, Grid, Collapse, Divider } from 'antd';


import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ProgrammeService from "../../api/programme.service";
import commonUtility from "../../utility/Utils";
import CustomTableSearch from "../common/CustomTableSearch";
import TapBookingGeneratedSchedule from "./TapBookingGeneratedSchedule";
const { Panel } = Collapse;

const TapDailyBookingCardView = (props) => {
    // const [paymentPaidList, setPaymentPaidList] = useState([]);
    // const [bookingTimeSlotList, setBookingTimeSlotList] = useState([]);
    // const [bookingTimeSlotListDetailView, setBookingTimeSlotListDetailView] = useState([]);
    // const [visible, setVisible] = useState(false);
    // const [filteredSearchList, setFilteredSearchList] = useState([]);

    // const [memberName, setMemberName] = useState("");
    // const [memberMobileNo, setMemberMobileNo] = useState("");
    // const [receiptNo, setReceiptNo] = useState("");
    const [bookingValidity, setBookingValidity] = useState("");

    let navigate = useNavigate();

    function changeLocation(placeToGo) {
        navigate(placeToGo, { replace: true });
        window.location.reload();
    }

    const collapseStyle = {
        width: '100%',
        maxWidth: '100%',
        marginBottom: 10
    };

    /*
     return (
         <div style={{marginTop:10}}>
             {props?.tapBookingList?.map((item) => (
                 <>
                     <Collapse collapsible="header" defaultActiveKey={['1']} style={collapseStyle}>
                         <Panel header={item.masterData.time_slot} key="1" style={{ fontWeight:'500'}}>
                             {
                                 item?.detailsData?.map((detailitem,index) => (
                                     <Col>
                                         <Card
                                             key={commonUtility.randomID()}
                                             size="small"
                                             title={ <h4 style={{color:'#407d3b'}}>{detailitem.member_fname + " " + detailitem.member_lname}</h4>}
                                             bordered={false}
                                             style={{
                                                 width: '200px',
                                                 height:'180px',
                                                 marginTop: 0,
                                                 border: '1px solid rgb(236, 236, 236)',
                                                 borderRadius: 2,
                                                 background: '#FFF'
                                             }}
 
                                         >
                                             <Row>
                                                 <Col span={24}>
                                                     {detailitem?.co_members?.split(',').map((step) => <h4 color="#f50" style={{ margin: 0 }}>{step}</h4>)}
                                                 </Col>
                                                     {
                                                         detailitem?.is_with_coach == "Y" ? 
                                                         <Col span={24}>
                                                             <Tag color="magenta">** With Coach **</Tag>
                                                         </Col> : 
                                                         <Col span={24}></Col>
                                                     }
                                                 <Col span={24} style={{marginTop:4}}>
                                                     <span style={{fontStyle:'italic',fontWeight:'600',color: 'rgb(153, 131, 10)'}}>{`${detailitem.book_start_month} to ${detailitem.book_end_month}`}</span>
                                                 </Col>
                                             </Row>
 
                                         </Card>
                                     </Col>
                                 ))
                             }
                         </Panel>
                     </Collapse>
                 </>
             ))}
         </div>
     );
 
    */




    return (
        <div style={{ marginTop: 5, background: '#FFF' }} key={commonUtility.randomID()}>
            {
                props?.tapBookingList.length > 0 ? <>
                    <Divider orientation="left" style={{ marginTop: 25 }}>List of Daily Booking {props.fromDate} </Divider>

                    <a href={`http://btaportal.in/custom/report/tap/printdailybooking/${props.fromDate}/2/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
                        <Button type="text" type="danger"><PrinterOutlined /> Print</Button>
                    </a>



                    {props?.tapBookingList?.map((item, index) => {
                        let count = 0;
                        let defaultkey = "panel" + index;

                        return (
                            <div key={commonUtility.randomID()}>
                                <Collapse collapsible="header" defaultActiveKey={[defaultkey]} style={collapseStyle}>
                                    <Panel header={item?.masterData?.time_slot != "" ? item?.masterData?.time_slot : ""} key={defaultkey} style={{ fontWeight: '500' }}>
                                        <Row key={commonUtility.randomID()}>
                                            {item?.detailsData?.map((detailitem, index) => {

                                                return (

                                                    <Col span={4} key={commonUtility.randomID()}>
                                                        <Card
                                                            //  key={commonUtility.randomID()}
                                                            size="small"
                                                            title={<h5 style={{ color: '#407d3b',fontWeight:600 }}>{detailitem.member_fname + " " + detailitem.member_lname}</h5>}
                                                            bordered={false}
                                                            style={{
                                                                width: 'auto',
                                                                height: '220px',
                                                                marginTop: 0,
                                                                border: '1px solid rgb(236, 236, 236)',
                                                                borderRadius: 2,
                                                                background: '#FFF'
                                                            }}

                                                        >
                                                            <Row key={commonUtility.randomID()}>

                                                                {/* <Col>
                                                            <span>Not Exist</span>
                                                        </Col> */}
                                                                <Col span={24}>
                                                                    {detailitem?.co_members?.split(',').map((step) => <h5 color="#f50" style={{ margin: 0 }}>{step}</h5>)}
                                                                </Col>
                                                                {
                                                                    detailitem?.is_with_coach == "Y" ?
                                                                        <Col span={24}>
                                                                            <Tag color="magenta">** With Coach **</Tag>
                                                                        </Col> :
                                                                        <Col span={24}></Col>
                                                                }
                                                                <Col span={24} style={{ marginTop: 4 }}>
                                                                    {
                                                                        detailitem.book_start_month != "" ? <>
                                                                            <span style={{ fontStyle: 'italic', fontWeight: '600', color: 'rgb(153, 131, 10)' }}>{`${detailitem.book_start_month} to ${detailitem.book_end_month}`}</span>
                                                                        </> : ""
                                                                    }

                                                                </Col>

                                                                <Col span={24} style={{ marginTop: 0 }}>
                                                                    <Row>
                                                                        <Col span={8}>
                                                                            {
                                                                               commonUtility.sanitizeObject(detailitem.receipt_no) != "" ? <><span style={{  fontWeight: '600', fontSize: '11px', color: '#515151' }}>Rcpt No </span></>  : ""
                                                                            }
                                                                        </Col>
                                                                        <Col span={16}>
                                                                            {
                                                                                commonUtility.sanitizeObject(detailitem.receipt_no) != "" ? <>
                                                                                    <span style={{  fontWeight: '600', fontSize: '11px', color: '#515151' }}>{detailitem.receipt_no}</span>
                                                                                </> : ""
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                                <Col span={24} style={{ marginTop: 0 }} hidden={commonUtility.sanitizeValue(detailitem.net_payble_amount) > 0 ? false : true}>
                                                                    <Row>
                                                                        <Col span={8}>
                                                                            {
                                                                                commonUtility.sanitizeObject(detailitem.receipt_date) != "" ? <><span style={{  fontWeight: '600', fontSize: '11px', color: '#515151' }}>Rcpt Dt </span></> : <></>
                                                                            }
                                                                        </Col>
                                                                        <Col span={16}>
                                                                            {
                                                                                commonUtility.sanitizeObject(detailitem.receipt_date) != "" ? <>
                                                                                    <span style={{ fontWeight: '600', fontSize: '11px', color: '#515151' }}>{detailitem.receipt_date}</span>
                                                                                </> : <></>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                                <Col span={24} style={{ marginTop: 0 }} hidden={commonUtility.sanitizeValue(detailitem.net_payble_amount) > 0 ? false : true}>
                                                                    <Row>
                                                                        <Col span={8}>
                                                                            {
                                                                                commonUtility.sanitizeObject(detailitem.net_payble_amount) != "" ? <>
                                                                                <span style={{ fontWeight: '600', fontSize: '11px', color: '#515151' }}>Amount </span>
                                                                                </> : <></>
                                                                            }
                                                                            
                                                                        </Col>
                                                                        <Col span={16}>
                                                                            {
                                                                                commonUtility.sanitizeObject(detailitem.net_payble_amount) != "" ? <>
                                                                                    <span style={{ fontWeight: '600', fontSize: '11px', color: '#515151' }}>{detailitem?.net_payble_amount?.toFixed(2)}</span>
                                                                                </> : <></>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                                
                                                            </Row>

                                                        </Card>
                                                    </Col>

                                                );

                                            })}
                                        </Row>


                                    </Panel>
                                </Collapse>
                            </div>
                        );
                    })}
                </> : <div key={commonUtility.randomID()}>
                    <h6></h6>
                </div>
            }

        </div>
    );


}


export default TapDailyBookingCardView;